import { render } from "./TableFit.vue?vue&type=template&id=aa2cf33e&ts=true"
import script from "./TableFit.vue?vue&type=script&lang=ts"
export * from "./TableFit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__